// extracted by mini-css-extract-plugin
export default {"noSelectedText":"PaymentProviderPanel_noSelectedText__dBJBu","supportLink":"PaymentProviderPanel_supportLink__Jp1p6"};